const Faculty = () => {
    return (
        <div id="faculty" className="vision-card">

            <h3 className="table-section-heading">
                FACULTY DETAILS
            </h3>

            <div className="table-section-wrap">
                <table className="table-section faculty-table">

                    <thead>
                        <tr>
                            <th colSpan="4">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        flexWrap: "wrap",
                                        width: "100%",
                                    }}
                                >
                                    <span>FACULTY DETAILS</span>

                                    <div style={{ textAlign: "right" }}>
                                        <div>09308-N J MISSION SCH PO KASIA KUSHINAGAR UP</div>
                                        <div>Date: 15-12-2016</div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                        <br />
                    </thead>

                    <tbody>
                        <tr>
                            <td>TOTAL NUMBER OF TEACHERS (ALL CLASSES)</td>
                            <td>83</td>
                            <td>NUMBER OF PGTs</td>
                            <td>30</td>
                        </tr>

                        <tr>
                            <td>NUMBER OF TGTs</td>
                            <td>36</td>
                            <td>NUMBER OF PRTs</td>
                            <td>17</td>
                        </tr>

                        <tr>
                            <td>NUMBER OF PETs</td>
                            <td>1</td>
                            <td>OTHER NON-TEACHING STAFF</td>
                            <td>15</td>
                        </tr>

                        <tr>
                            <td>NUMBER OF MANDATORY TRAINING QUALIFIED TEACHERS</td>
                            <td>05</td>
                            <td>NUMBER OF TRAININGS ATTENDED BY FACULTY SINCE LAST YEAR</td>
                            <td>05</td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>

    );
};

export default Faculty;